/**
 * Monta URL absoluta do PDF servido em GET /public/certificados/{path}
 * A API pode devolver arquivo_pdf como "712", "certificados/712", "/public/certificados/712", etc.
 */
export function getCertificadoPdfUrl(arquivoPdf) {
	if (arquivoPdf == null || arquivoPdf === "") return null;
	let cleanPath = String(arquivoPdf)
		.trim()
		.replace(/^\/+/, "")
		.replace(/^public\/certificados\/+/i, "")
		.replace(/^certificados\/+/i, "");
	/** Evita segmento duplicado quando o legado gravou "certificado/certificado/…" dentro de certificados/. */
	cleanPath = cleanPath.replace(/^certificado\/certificado(\/|$)/i, "certificado$1");
	const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
	return `${apiBase}/public/certificados/${cleanPath}`;
}
